module.exports = __webpack_public_path__ + "static/img/photo_anquan.ee4f9d7.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/photo/photo_anquan.png
// module id = lvsH
// module chunks = 12